<template>
	<v-container class="login-page">
		<v-col md="5" offset-md="3" :class="{ 'margin-bottom': $vuetify.breakpoint.mdAndUp }">
			<h1 class="login-page__title">Login</h1>

			<span class="mb-4 d-inline-block login-page__terms">{{ authHelpMessage }}</span>

			<LoginForm />
		</v-col>
	</v-container>
</template>

<script>
import LoginForm from '@/components/Forms/LoginForm'
import { mapGetters } from 'vuex'

export default {
	name: 'LoginPage',
	components: {
		LoginForm,
	},
	computed: {
		...mapGetters('settings', ['login']),

		authHelpMessage() {
			const {
				auth_message: authMessage
			} = this.login || {}

			return authMessage || 'Use your Clowder® credentials to log in'
		}
	},
	methods: {
		navigateToRegisterPage() {
			this.$router.push({ name: 'register' })
		},
		navigateToTermsPage() {
			this.$router.push({ name: 'terms-and-privacy' })
		},
	}
}
</script>

<style lang="scss">
.login-page {
	&__title {
		color: rgb(74, 74, 74);
		font-size: 33px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
	}

	&__terms {
		color: rgba(0, 0, 0, 0.6);
		font-weight: 400;
	}
}
.left-section {
	background-color: var(--accent-color);
}
</style>
